import {createRouter, createWebHistory} from 'vue-router'
import MainLayout from "@/views/layout/MainLayout";


const routes = [
    {
        path: '/',
        component: MainLayout,
        children: [
            {
                path: '/',
                component: () => import("@/components/AdminPage")
            }
        ]
    },
    {
        path: '/role',
        component: MainLayout,
        children: [
            {
                path: 'main',
                component: () => import("@/components/role/RolePage.vue")
            },
            {
                path: 'create',
                component: () => import("@/components/role/CreateRolePage.vue"),
            },
            {
                path: 'detail/:role_id',
                component: () => import("@/components/role/RoleDetailPage.vue"),
                props: true
            }
        ]
    },
    {
        path: '/kbase',
        component: MainLayout,
        children: [
            {
                path: 'main',
                component: () => import("@/components/kbase/KBasePage.vue")
            },
            {
                path: 'detail/:kbase_id',
                props: true,
                component: () => import("@/components/kbase/KBaseDetailPage.vue")
            },
        ]
    },
    {
        path: '/admin',
        component: MainLayout,
        children: [
            {
                path: 'profile',
                component: () => import("@/components/admin/ProfilePage.vue")
            }
        ]
    },
    {
        path: '/login',
        component: () => import("@/components/LoginPage")
    },
    {
        path: '/init_pass',
        component: () => import("@/components/InitPassPage")
    },
]

const router = createRouter({
        history: createWebHistory(),
        routes
    }
)
export default router
